import Vue from 'vue';
import Vuex from 'vuex';
import VueJwtDecode from 'vue-jwt-decode';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import router from '../router';
import config from '../../config';
import JSEncrypt from 'jsencrypt';

import associazioniModule from './modules/associazioniModule';
import associatiModule from './modules/associatiModule';
import eventiModule from './modules/eventiModule';
import errorsModule from './modules/errorsModule';
import sharedModule from './modules/sharedModule';
import notificheModule from './modules/notificheModule';
import Security from '@/security';

Vue.use(Vuex);

const state = {
  jwt: null,
  checkRole: null,
  expires: null,
  menus: null,
  userData: null,
  dataCalendario: null,
};

const mutations = {
  // setto token e scadenza token nel localstorage
  setJwt(state, responseData) {
    const now = new Date();
    state.jwt = responseData.token;
    state.expires = new Date(now.setSeconds(now.getSeconds() + responseData.expires_in));
    // router.replace('/');
  },
  // cancello localstorage
  clearJwt(state) {
    for (const prop of Object.keys(state)) {
      state[prop] = null;
    }
    localStorage.clear();
    router.replace('/login');
  },
  setMenu(state, inMenu) {
    state.menus = inMenu;
  },
  setUserData(state, userEntity) {
    state.userData = userEntity;
  },
  setDataCalendario(state, data) {
    state.dataCalendario = data;
  },
};

const actions = {
  logout({ commit, state }) {
    commit('clearJwt', state);
    router.replace('/login');
  },
  loginToken({ dispatch, commit, state }, tokenLogin) {
    const myToken = tokenLogin.token;
    const myPage = tokenLogin.page != '§home' ? '/' + tokenLogin.page.split('§').join('/') : '/';
    const myAccess = tokenLogin.access != null ? tokenLogin.access : 'APP';
    // eslint-disable-next-line no-console
    console.log(tokenLogin);
    axios.post(config.ROOT_API + '/api/user/loginToken', { token: myToken }).then(function (response) {
      if (response.data.token) {
        // eslint-disable-next-line no-console
        commit('setJwt', response.data);
        let anagraficaObj = { tipoAccesso: myAccess };
        commit('setUserData', anagraficaObj);

        if (response.data.user.role === 'ASSOCIATO' || response.data.user.role == 'UTENTE') {
          axios.get(config.ROOT_API + '/api/associati/profile/' + response.data.user.id).then((resp) => {
            if (resp.data.id) {
              anagraficaObj.id = resp.data.id;
              anagraficaObj.Denominazione = resp.data.Denominazione;
              anagraficaObj.Nome = resp.data.Nome;
              anagraficaObj.Cognome = resp.data.Cognome;
              anagraficaObj.Email = resp.data.Email;
              anagraficaObj.Tipo = resp.data.Tipo;
              anagraficaObj.AssociazioneId = resp.data.associazioneId;
              anagraficaObj.Role = response.data.user.role;
              anagraficaObj.userid = response.data.user.id;
              anagraficaObj.userName = response.data.user.username;
              anagraficaObj.Open = resp.data.Open == 1;
              anagraficaObj.tipoAccesso = myAccess;
              commit('setUserData', anagraficaObj);
              router.replace(myPage);
            } else {
              // eslint-disable-next-line no-console
              console.log('ERRORE');
              return false;
            }
          });
        } else if (response.data.user.role === 'RESPONSABILE_ASSOCIAZIONE') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = 0;
          anagraficaObj.AssociazioneId = response.data.user.Tag;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userid = response.data.user.id;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = myAccess;
          commit('setUserData', anagraficaObj);
          router.replace(myPage);
        } else if (response.data.user.role === 'UTENTE_AMMINISTRATIVO') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = response.data.user.id;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = myAccess;
          commit('setUserData', anagraficaObj);
          router.replace(myPage);
        } else if (response.data.user.role === 'VIEWER') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = response.data.user.id;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = myAccess;
          commit('setUserData', anagraficaObj);
          router.replace(myPage);
        }
      } else {
        // eslint-disable-next-line no-console
        router.replace('/DenyApp');
        return false;
      }
    });
  },
  login({ dispatch, commit, state }, user, resultUsername) {
    axios.post(config.ROOT_API + '/api/user/login', user).then(function (response) {
      if (response.data.token) {
        commit('setJwt', response.data);
        let anagraficaObj = {};

        if (response.data.user.role === 'ASSOCIATO' || response.data.user.role == 'UTENTE') {
          axios.get(config.ROOT_API + '/api/associati/profile/' + response.data.user.id).then((resp) => {
            if (resp.data.id) {
              anagraficaObj.id = resp.data.id;
              anagraficaObj.Denominazione = resp.data.Denominazione;
              anagraficaObj.Nome = resp.data.Nome;
              anagraficaObj.Cognome = resp.data.Cognome;
              anagraficaObj.Email = resp.data.Email;
              anagraficaObj.Tipo = resp.data.Tipo;
              anagraficaObj.AssociazioneId = resp.data.associazioneId;
              anagraficaObj.Role = response.data.user.role;
              anagraficaObj.userid = response.data.user.id;
              anagraficaObj.userName = response.data.user.username;
              anagraficaObj.Open = resp.data.Open == 1;
              anagraficaObj.tipoAccesso = 'WEB';
              commit('setUserData', anagraficaObj);
              router.replace('/');
            } else {
              // eslint-disable-next-line no-console
              console.log('ERRORE');
              return false;
            }
          });
        } else if (response.data.user.role === 'RESPONSABILE_ASSOCIAZIONE') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = 0;
          anagraficaObj.AssociazioneId = response.data.user.Tag;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userid = response.data.user.id;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = 'WEB';
          commit('setUserData', anagraficaObj);
          router.replace('/');
        } else if (response.data.user.role === 'UTENTE_AMMINISTRATIVO') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = response.data.user.id;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = 'WEB';
          commit('setUserData', anagraficaObj);
          router.replace('/');
        } else if (response.data.user.role === 'VIEWER') {
          anagraficaObj.Role = response.data.user.role;
          anagraficaObj.id = response.data.user.id;
          anagraficaObj.Denominazione = response.data.user.username;
          anagraficaObj.userName = response.data.user.username;
          anagraficaObj.tipoAccesso = 'WEB';
          commit('setUserData', anagraficaObj);
          router.replace('/');
        }
      } else {
        // eslint-disable-next-line no-console
        console.log('ERRORE');
        return false;
      }
    });
  },
  changePassword({ commit, state }, userNewOldPass) {
    axios.post(config.ROOT_API + '/api/user/changePassword', userNewOldPass).then(function (response) {
      // eslint-disable-next-line no-console
      console.log(response);
    });
  },
  unauthorized({ commit, state }) {
    router.replace('/403');
  },
  async loadMenu({ commit, state }) {
    if (state.jwt) {
      return axios
        .get(config.ROOT_API + '/api/menu')
        .then(function (response) {
          let menu = response.data;
          if (menu) {
            commit('setMenu', menu);
          } else {
            return false;
          }
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
          commit('setMenu', null);
        });
    } else {
      commit('setMenu', null);
    }
  },
  changeDataCalendario({ commit, state }, data) {
    commit('setDataCalendario', data);
  },
};

const getters = {
  jwt: (state) => state.jwt,
  expires: (state) => state.expires,
  // controllo se esiste token e se è valido
  isLogged: (state) => {
    const now = new Date();
    if (!!state.jwt && now < new Date(state.expires)) {
      return true;
    } else {
      return false;
    }
  },
  checkRole: (state) => {
    if (state.jwt) {
      return VueJwtDecode.decode(state.jwt)['role'];
    }
  },
  menus: (state) => {
    let menu = [];
    if (state.userData) {
      if ((state.userData.Role && state.userData.Role === Security.ruolo.UTENTE_AMMINISTRATIVO) || state.userData.Role === Security.ruolo.ADMIN) {
        menu = state.menus;
      } else {
        if (state.menus) {
          menu = state.menus.filter((e) => {
            return e.isAdmin == 0;
          });
        }
      }
    }
    return menu;
  },
  userData: (state) => {
    if (state.userData) {
      return state.userData;
    }
  },
  dataCalendario: (state) => state.dataCalendario || new Date(),
};

export default new Vuex.Store({
  modules: {
    sharedModule,
    errorsModule,
    associazioniModule,
    associatiModule,
    eventiModule,
    notificheModule,
  },
  plugins: [createPersistedState()],
  state,
  getters,
  actions,
  mutations,
});
